import { Component, Input, OnInit } from '@angular/core';
import { MetaDataDto } from "dto/MetadataDto";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'messagebox',
  templateUrl: './messagebox.component.html',
  styleUrls: ['./messagebox.component.css']
})
export class MessageboxComponent implements OnInit {

  @Input() Properties:any;
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/messagebox/messagebox.component.ts